type DinamicPage = {
    id: number
    "pluginspaceId": number
    "aggregatorClassificationId": number
    "pluginSpaceAggregatorId": number
    "title": string
    "slug": string
    "description": string
    "seoTitle": string
    "seoDescription": string
    "shareImage": string
    "status": boolean,
    "order": number,
    "created": "2026-08-28T21:16:17.030Z",
    "updated": "2026-08-28T21:16:17.030Z",
    "deleted": string | null,
    grids: GridPage[]
}

type GridPage = {
    "id": number,
    "aggregatorDinamicPageId": number,
    "pluginspaceId": number,
    "type": TypeDinamicGrid,
    "order": number,
    "status": boolean,
    "configuration": any,
    "created": string,
    "updated": string,
    "deleted": string | null
}

type DinamicPageCreate = {
    title: string
    description: string
    aggregatorClassificationId: number
    storeId: number
    order: number
    slug: string
    status: boolean,
    seoTitle: string,
    seoDescription: string,
    shareImage: File | string,
    grids: DinamicGridCreate[]
}

type DinamicGridCreate = {
    id: string
    order: number
    type: TypeDinamicGrid
    configuration: ContentCreate
}

type ContentCreate = {
    title?: string
    text?: string
    image?: string | File
    images?: string[] | File[]
}

type FieldType = 'text' | 'textarea' | 'image' | 'images';

type ContentFieldConfig = {
    field: keyof ContentCreate;
    type: FieldType;
    required?: boolean;
    min?: number;
    max?: number;
    label?: string;
};
export enum TypeDinamicGrid {
    image = 'image', // only one image
    carousel = 'carousel', // only image can be 1 to 4
    text = 'text', // only text
    content = 'content', // title + text
    hero = 'hero', // title + text + image
    galery = 'gallery', // title + text + images
    video = 'video', // title + text + video
    map = 'map', // title + text + map
    products = 'products', // title + text + products
    events = 'events', // title + text + events
    promotions = 'promotions', // title + text + promotions
    news = 'news', // title + text + news
    services = 'services', // title + text + services
    faqs = 'faqs', // title + text + faqs
}


type ContentField = {
    field: keyof ContentCreate
    label?: string
    maxLength?: number
    min?: number
    max?: number
}

export const ContentConfig: Record<TypeDinamicGrid, ContentField[]> = {
    [TypeDinamicGrid.image]: [
        {
            field: 'image',
            min: 1,
            max: 1,
        },
    ],

    [TypeDinamicGrid.carousel]: [
        {
            field: 'images',
            min: 1,
            max: 4,
        },
    ],

    [TypeDinamicGrid.text]: [
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.content]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.hero]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
        {
            field: 'image',
            min: 1,
            max: 1,
        },
    ],

    [TypeDinamicGrid.galery]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
        {
            field: 'images',
            min: 1,
            max: 20,
        },
    ],

    [TypeDinamicGrid.video]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.map]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.products]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.events]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.promotions]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.news]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.services]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],

    [TypeDinamicGrid.faqs]: [
        {
            field: 'title',
        },
        {
            field: 'text',
            maxLength: 500,
        },
    ],
}

type TableParams = {
    page?: number
    pageSize?: number
    search?: string
    sorting?: { field: string; direction: 'asc' | 'desc' }
}

type UpdateDinamicPage = Partial<DinamicPageCreate>



export type { DinamicPage, DinamicPageCreate, DinamicGridCreate, ContentCreate, ContentField, ContentFieldConfig, FieldType, TableParams, UpdateDinamicPage }